import { useProvideInject } from '@/composition/provideInject'
import type { DetailsTableLabelSize } from '@/components/shared/templates/types'
import { detailsTableLabelSizeSymbol } from '@/components/shared/templates/types'

export const useDetailsTableLabelSize = () => useProvideInject<DetailsTableLabelSize>(detailsTableLabelSizeSymbol)

export type DetailsTableType = 'details' | 'result'
